import React from 'react';
import { FormattedText } from 'core/i18n';
import { getLegalItems } from './utils/getLegalIndex';

export const LegalIndex = ({ productsInfo }) => {
    return (
        <div>
            <FormattedText value="documentation-gdprLegalIndexTitle" />
            <div className="index-block">
                <ul>{getLegalItems(productsInfo)}</ul>
            </div>
        </div>
    );
};
